import React, {Component} from 'react';
import './CreateNotificationPopup.css';
import Label from "../../components/label/Label";
import Card from "../../components/card/Card";
import Popup from "../../components/popup/Popup";
import UniversalDropDown from "../../components/universalDropDown/UniversalDropDown";
import Input from "../../inputs/input/Input";
import toasts from "../../utils/toasts";
import {invalidEmails} from "../../pages/settingsPage/SettingsPage";
import PrimaryButton from "../../components/primaryButton/PrimaryButton";
import mainAPI from "../../api/MainAPI";

const allHours = {
  '1': '1 am',
  '2': '2 am',
  '3': '3 am',
  '4': '4 am',
  '5': '5 am',
  '6': '6 am',
  '7': '7 am',
  '8': '8 am',
  '9': '9 am',
  '10': '10 am',
  '11': '11 am',
  '12': 'Noon',
  '13': '1 pm',
  '14': '2 pm',
  '15': '3 pm',
  '16': '4 pm',
  '17': '5 pm',
  '18': '6 pm',
  '19': '7 pm',
  '20': '8 pm',
  '21': '9 pm',
  '22': '10 pm',
  '23': '11 pm',
  '0': "Midnight",
}

const allDays = {
  '1': '1st',
  '2': '2nd',
  '3': '3rd',
  '4': '4th',
  '5': '5th',
  '6': '6th',
  '7': '7th',
  '8': '8th',
  '9': '9th',
  '10': '10th',
  '11': '11th',
  '12': '12th',
  '13': '13th',
  '14': '14th',
  '15': '15th',
  '16': '16th',
  '17': '17th',
  '18': '18th',
  '19': '19th',
  '20': '20th',
  '21': '21st',
  '22': '22nd',
  '23': '23rd',
  '24': '24th',
  '25': '25th',
  '26': '26th',
  '27': '27th',
  '28': '28th',

}

const notificationTypes = {
  primary_daily_box_check: 'Inventory Check',
  primary_daily_administration: 'Administration',
  account_below_par: 'Drug Below Par',
};

const getNotificationTypes = (unitId, dayOrHour) => {
  if (unitId) {
    return {
      primary_daily_box_check: 'Inventory Check',
    }
  } else if (dayOrHour === 'notification_by_day') {
		return {
			primary_daily_box_check: 'Inventory Check',
			account_below_par: 'Drug Below Par',
		}
	} else {
    return notificationTypes;
  }

};

export const NotificationExplanationMessage = ({
                                                 day_or_hour,
                                                 type,
                                                 start_hour,
                                                 end_hour,
                                                 start_day_of_month,
                                                 end_day_of_month,
                                                 className
                                               }) => {
  if (day_or_hour === 'notification_by_hour') {
    return toExplanationMessageByHour(type, start_hour, end_hour, className + ' g-notification-explanation-message')
  }
  return toExplanationMessageByDay(type, start_day_of_month, end_day_of_month, className + ' g-notification-explanation-message')
}

const toExplanationMessageByDay = (type, start_day_of_month, end_day_of_month, className) => {
	let ofPreviousMonth = ''
	if(start_day_of_month >= end_day_of_month){
		ofPreviousMonth = <Label bold black>(of the previous month)</Label>
	}
  if (type === 'primary_daily_box_check') {
    return <Label className={className}>Notifications will be sent for <Label bold black>Inventory Checks</Label> not
      completed between the <Label bold black>{allDays[start_day_of_month]}</Label> day of the month {ofPreviousMonth} and the<Label bold
                                                                                                                 black>{allDays[end_day_of_month]}</Label> day
      of the month</Label>
  }
  if (type === 'primary_daily_administration') {
    return <Label className={className}>Notifications will be sent for <Label bold black>Administrations</Label> created
      between the <Label bold black>{allDays[start_day_of_month]}</Label> day of the month {ofPreviousMonth} and the<Label bold
                                                                                                       black>{allDays[end_day_of_month]}</Label> day
      of the month</Label>
  }
  if (type === 'account_below_par') {
    return <Label className={className}>Notifications will be sent daily for drug inventories below par on the <Label
      bold black> {allDays[end_day_of_month]}</Label> day of the month</Label>
  }
  return <></>
};

const toExplanationMessageByHour = (type, start_hour, end_hour, className) => {
	let onThePreviousDay = ''
	if(start_hour >= end_hour){
		onThePreviousDay = ' on the previous day '
	}
  if (type === 'primary_daily_box_check') {
    return <Label className={className}>Notifications will be sent for <Label bold black>Inventory Checks</Label> not
      completed between <Label bold black>{allHours[start_hour]} {onThePreviousDay}</Label> and <Label bold
                                                                                    black>{allHours[end_hour]}</Label></Label>
  }
  if (type === 'primary_daily_administration') {
    return <Label className={className}>Notifications will be sent for <Label bold black>Administrations</Label> created
      between <Label bold black>{allHours[start_hour]} {onThePreviousDay}</Label> and <Label bold
                                                                          black>{allHours[end_hour]}</Label></Label>
  }
  if (type === 'account_below_par') {
    return <Label className={className}>Notifications will be sent daily for drug inventories below par at <Label bold
                                                                                                                  black>{allHours[end_hour]}</Label></Label>
  }
  return <></>
};

export default class CreateNotificationPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      start_hour: 0,
      end_hour: 9,
      start_day_of_month: 1,
      end_day_of_month: 28,
      type: 'primary_daily_box_check',
      email_list: '',
      day_or_hour: props.day_or_hour || 'notification_by_day',
      unit_id: props.unitId
    }
  }

  get emptyState() {
    return {
      name: '',
      start_hour: 0,
      end_hour: 0,
      start_day_of_month: 1,
      end_day_of_month: 1,
      type: 'primary_daily_box_check',
      email_list: '',
      day_or_hour: 'notification_by_day',
      unit_id: this.props.unitId
    }
  };

  componentDidMount = async () => {
    if (this.props.id) {
      this.setState({...this.emptyState, day_or_hour: this.props.day_or_hour});
      if (this.props.day_or_hour === 'notification_by_day') {
        const notification = await mainAPI.notification_by_day.get(this.props.id);
        this.setState({
          name: notification.name,
          start_hour: notification.start_hour,
          end_hour: notification.end_hour,
          start_day_of_month: notification.start_day_of_month,
          end_day_of_month: notification.end_day_of_month,
          type: notification.type,
          email_list: notification.email_list,
          unit_id: notification.unit_id,
          unit__name: notification.unit__name,
        })
      }
      if (this.props.day_or_hour === 'notification_by_hour') {
        const notification = await mainAPI.notification_by_hour.get(this.props.id);
        this.setState({
          name: notification.name,
          start_hour: notification.start_hour,
          end_hour: notification.end_hour,
          start_day_of_month: notification.start_day_of_month,
          end_day_of_month: notification.end_day_of_month,
          type: notification.type,
          email_list: notification.email_list,
          unit_id: notification.unit_id,
					unit__name: notification.unit__name,
				})
      }
    }
  };

  setEmails = (value) => {
    value = value.toLowerCase().replace(/ /g, '');
    const invalid = invalidEmails(value);
    this.setState({invalidInventoryCheckSecondaryEmails: invalid, email_list: value});
  };

  isValid = () => {
    const emails = this.state.email_list.toLowerCase().replace(/ /g, '');
    const invalid = invalidEmails(emails);
    if (invalid.length > 0) {
      toasts.show('Invalid email');
      return false;
    }
    return true;
  };
  close = () => {
    window.popupController.hide(CreateNotificationPopup);
    if (this.props.onClose) this.props.onClose();
  };
  delete = async () => {
    if (this.state.day_or_hour === 'notification_by_hour') {
      await mainAPI.notification_by_hour.delete({id: this.props.id})
      toasts.show('Deleted')
      this.close();
    }
    if (this.state.day_or_hour === 'notification_by_day') {
      await mainAPI.notification_by_day.delete({id: this.props.id})
      toasts.show('Deleted')
      this.close();
    }
  }

  update = async () => {
    const notification = this.state;
    let response = null;
    if (this.state.day_or_hour === 'notification_by_hour') {
      response = await mainAPI.notification_by_hour.update({...notification, id: this.props.id});
    } else {
      response = await mainAPI.notification_by_day.update({...notification, id: this.props.id});
    }
    if (response) {
      toasts.show('Notification updated')
      this.close()
    } else {
      toasts.show('Could not save notification')
    }
  };

  save = async () => {
    if (!this.isValid()) return;
    if (this.props.id) {
      return this.update();
    }
    const notification = this.state;
    let response = null;
    if (this.state.day_or_hour === 'notification_by_hour') {
      response = await mainAPI.notification_by_hour.create({...notification, timezone: getTimezone()});

    } else {
      response = await mainAPI.notification_by_day.create({...notification, timezone: getTimezone()});
    }
    if (response) {
      toasts.show('Notification saved')
      this.close()
    } else {
      toasts.show('Could not save notification')
    }
  };

  hourOrDates = () => {
    if (this.state.day_or_hour === 'notification_by_hour') {
      return <>
        {(this.state.type != 'account_below_par') && <UniversalDropDown value={this.state.start_hour}
                                                                        onChange={start_hour => this.setState({
                                                                          ...this.state,
                                                                          start_hour
                                                                        })} required
                                                                        placeholder='Start Hour'
                                                                        options={allHours}></UniversalDropDown>}
        <UniversalDropDown value={this.state.end_hour}
                           onChange={end_hour => this.setState({...this.state, end_hour})}
                           required placeholder='End Hour' options={allHours}></UniversalDropDown>

      </>
    } else {
      return <>
        {(this.state.type != 'account_below_par') && <UniversalDropDown value={this.state.start_day_of_month}
                                                                        onChange={start_day_of_month => this.setState({
                                                                          ...this.state,
                                                                          start_day_of_month
                                                                        })} required
                                                                        placeholder='Start Day of Month'
                                                                        options={allDays}></UniversalDropDown>}
        <UniversalDropDown value={this.state.end_day_of_month}
                           onChange={end_day_of_month => this.setState({...this.state, end_day_of_month})}
                           required placeholder='End Day of Month' options={allDays}></UniversalDropDown>
      </>
    }
  };

  render() {
		let unitName = '';
		if(this.state.unit__name){
			unitName = ` (${this.state.unit__name})`
		}
    return (
      <Popup {...this.props} onClose={this.close} className="g-create-notification-popup" role="alertdialog">
        <Card>
          <Label larger black>
            Notification {unitName}
          </Label>
          <Label>Name</Label>
          <Input placeholder={'Name (General Notification)'} value={this.state.name} onChange={name => this.setState({
            ...this.state,
            name
          })}></Input>
          <NotificationExplanationMessage {...this.state} />
          <div className={'column'}>
            {this.hourOrDates()}
            <UniversalDropDown value={this.state.type} onChange={type => this.setState({...this.state, type})}
                               required
                               placeholder='Type'
                               options={getNotificationTypes(this.props.unitId, this.state.day_or_hour)}></UniversalDropDown>
            <Label gray-dark>(e.g., email1@gmail.com,email2@yahoo.com)</Label>
            <Input value={this.state.email_list} placeholder={'emails'} onChange={this.setEmails}/>
            {this.state.invalidInventoryCheckSecondaryEmails && (
              <Label>invalid emails {this.state.invalidInventoryCheckSecondaryEmails}</Label>
            )}
          </div>
          {this.state.email_list && <PrimaryButton center onClick={this.save}>Save</PrimaryButton>}
          {this.props.id && <PrimaryButton className={'red'} center onClick={this.delete}>Delete</PrimaryButton>}
        </Card>
      </Popup>
    )
  }
}


const getTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};


// WEBPACK FOOTER //
// ./src/popups/createNotificationPopup/CreateNotificationPopup.jsx